import React, { useEffect} from 'react';
// import 'bootstrap/dist/css/bootstrap.min.css';
import 'antd/dist/antd.css';
import './App.css';
import './style.css';
import LoginForm from './components/LoginForm/LoginForm';
import RegistrationForm from './components/RegistrationForm/RegistrationForm';
import Home from './components/Home/Home';
import Joblist from './components/jobs/Joblist'
import Profile from './components/Profile/Profile'
// {import CandidatesList from './components/Candidates/CandidatesList'}
import routes from './components/Routes'
import ContactUs from './components/Contact/ContactUs'
import AboutUs from './components/About/AboutUs'
// import Profile from './components/Profile/Profile'
import { BrowserRouter as Router, Route,Redirect,HashRouter} from "react-router-dom";
// import { HashRouter } from 'react-router-dom'
import { connect } from 'react-redux'

import {getAllField} from './Action/index'
const App=(props)=>{
 
  //alert("rerender")
useEffect(() => {
  const login = JSON.parse(localStorage.getItem("login"))
  props.login(login)
  if(props.allfeild===""){
    props.getAllField()
  }
 // alert("dfsdkh")
}, [])
 
  const login=props.login_info
  const authGuard = (Component) => () => {
    //console.log(props.login,"props.login")
    // var login=props.login
    return  login? (
      <Component />
    ) : (
      <Redirect to="/login" />
    );
  };
  
  return (

    <Router>
     <Route path={routes.home} exact={true} component={Home}></Route>
     <Route  path={routes.login}  >
          <LoginForm   onSuccess={() => {}}/>
     </Route>
     <Route   path={routes.signup} component={RegistrationForm}></Route>
     <Route   path={routes.job} component={Joblist}></Route>
   {/* {  <Route path={routes.candidates} component={CandidatesList}></Route>} */}
     <Route path={routes.about} component={AboutUs}></Route>
  
   {/* {  <ProtectedRoute path={routes.profile} component={Profile} />} */}
    <Route   path={routes.profile}  render={authGuard(Profile)}></Route>
    <Route   path={routes.contact} component={ContactUs}></Route>
    </Router>
  );
}
const mapStateToProps=(state)=>{
  return{
    allfeild:state.list.allfeild,
    login_info:state.list.login,
  }
  }
  const mapDispatchToProps = (dispatch) => {
      return {
        login:(data)=>dispatch({type: "LOGIN_INFO", payload: data}),
        getAllField:()=>dispatch(getAllField())
      };
    };
  export default connect(mapStateToProps,mapDispatchToProps)(App);
//export default App;
//  {/* {<div>hello in each page </div>} */}
//  <div className="App">
//  <Header title={title} counter={counter} />
//  <div className="container d-flex align-items-center flex-column">
//    <Switch>
//      <Route path="/" exact={true}>
//        {/* {              <RegistrationForm showError={updLoginFormateErrorMessage} updateTitle={updateTitle} steps={setcounter}/>} */}
//        {/* <Home  updateTitle={updateTitle}/> */}
//        <LoginForm showError={updateErrorMessage} updateTitle={updateTitle} />
//      </Route>
//      <Route path="/register">
//        <RegistrationForm showError={updateErrorMessage} updateTitle={updateTitle} steps={setcounter} />
//      </Route>
//      <Route path="/login">
//        <LoginForm showError={updateErrorMessage} updateTitle={updateTitle} />
//      </Route>
//      <Route path="/home">
//        <Home updateTitle={updateTitle} showError={updateErrorMessage}/>
//      </Route>
//      <Route path="/Jobs">
//        <Joblist updateTitle={updateTitle} showError={updateErrorMessage}/>
//      </Route> 
//       <Route path="/Profile">
//        <Profile updateTitle={updateTitle} showError={updateErrorMessage}/>
//      </Route>
//    </Switch>
//    <AlertComponent errorMessage={errorMessage} hideError={updateErrorMessage} />
//  </div>
// </div>
// {/* {title=="Home"&&<footer>
//  <p>Author: Hege Refsnes</p>
//  <p><a href="mailto:hege@example.com">hege@example.com</a></p>
// </footer>} */}
// {<Footer/>}

//another wat to royute 
//<Route path="/" exact component={() =>
//  <div>
// <Login
//     isAuthenticated={this.state.isAuthenticated}
//     setAuthenticated={this.setAuthenticated}
// </div>
// } /> 




 
// import React from "react";

// import {
//   Route,
//   BrowserRouter as Router,
//   Switch,
//   Redirect,
// } from "react-router-dom";

// import Login from "./Pages/Login/Login";
// import Register from "./Pages/Register/Register";
// import Dashboard from "./Pages/Dashboard/Dashboard";
// import NotFound from "./Pages/NotFound/NotFound";

// const authGuard = (Component) => () => {
//   return localStorage.getItem("token") ? (
//     <Component />
//   ) : (
//     <Redirect to="/login" />
//   );
// };
// const Routes = (props) => (
//   <Router {...props}>
//     <Switch>
//       <Route path="/login">
//         <Login />
//       </Route>
//       <Route path="/register">
//         <Register />
//       </Route>
//       <Route path="/dashboard" render={authGuard(Dashboard)}></Route>
//       <Route exact path="/">
//         <Redirect to="/dashboard" />
//       </Route>
//       <Route path="*">
//         <NotFound />
//       </Route>
//     </Switch>
//   </Router>
// );

// export default Routes;